// ** React Imports
import { useEffect, useState } from 'react'

// ** MUI Import
import GlobalStyles from '@mui/material/GlobalStyles'

/**
 * Reserva el espacio que ocupa una barra fija al pie de la pagina.
 *
 * /beast/ y /college/ montan un <AppBar position='fixed' bottom={0}> con la barra de
 * progreso y los botones de llenar y limpiar. MUI le pone z-index 1100; el pie del
 * sitio es sticky con z-index 10. O sea que en esas dos paginas la barra tapaba el
 * pie entero —86 px medidos, en movil y en escritorio— y con el, los enlaces a la
 * politica de privacidad y a los terminos. Se veian a medias en la captura y no se
 * podian pulsar: un clic sobre ellos lo recibia la barra.
 *
 * No alcanzaba con subirle el z-index al pie: eso tapa la barra, que es el control
 * principal de la herramienta. Lo que corresponde es que convivan, y para eso el pie
 * se levanta exactamente lo que mide la barra.
 *
 * El alto se mide en vez de escribirse: la barra lleva una <Toolbar>, cuyo alto
 * cambia con el breakpoint y con la densidad del tema, y un numero a mano se queda
 * viejo en el primer cambio que nadie relacione con esto.
 */
const HuecoBarraInferior = ({ selector = '.barra-inferior-fija' }) => {
  const [alto, setAlto] = useState(0)

  useEffect(() => {
    const barra = document.querySelector(selector)
    if (!barra) return

    const medir = () => setAlto(Math.ceil(barra.getBoundingClientRect().height))
    medir()

    const observador = new ResizeObserver(medir)
    observador.observe(barra)

    return () => observador.disconnect()
  }, [selector])

  if (!alto) return null

  return (
    <GlobalStyles
      styles={{
        // El pie sticky se pinta justo encima de la barra en vez de debajo
        'footer.layout-footer': { bottom: `${alto}px` },
        // Y el final del contenido deja de quedar oculto tras ella al llegar abajo
        '.layout-content-wrapper': { paddingBottom: `${alto}px` }
      }}
    />
  )
}

export default HuecoBarraInferior
